import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as AOS from 'aos';
import { from } from 'rxjs';
import { LinkService } from '../../../_services/langhfre.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-k12-and-elearning',
  templateUrl: './k12-and-elearning.component.html',
  styleUrls: ['./k12-and-elearning.component.scss']
})
export class K12AndElearningComponent implements OnInit {

  email: any;
  // emailEnterprise : FormGroup;
  country: string;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    public loadScript: LoadScriptService
  ) {
    
  }

  ngOnInit() {
    this.titleService.setTitle("트링카 엔터프라이즈 | K-12 및 E-러닝");
    this.metaTagService.updateTag({ name: 'description', content: "트링카의 고급 AI는 학생들이 글쓰기를 향상하는 것은 물론 글을 쓸 때 최고의 학술적 글쓰기 관행을 배울 수 있도록 돕습니다." });
    this.metaTagService.updateTag({ property: 'og:title', content: "트링카 엔터프라이즈 | K-12 및 E-러닝" });
    this.metaTagService.updateTag({ property: 'og:description', content: "트링카의 고급 AI는 학생들이 글쓰기를 향상하는 것은 물론 글을 쓸 때 최고의 학술적 글쓰기 관행을 배울 수 있도록 돕습니다." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/enterprise/k12-and-elearning' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/K12-and-elearning.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '트링카 엔터프라이즈 | K-12 및 E-러닝' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "트링카의 고급 AI는 학생들이 글쓰기를 향상하는 것은 물론 글을 쓸 때 최고의 학술적 글쓰기 관행을 배울 수 있도록 돕습니다." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/K12-and-elearning.png' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/k12-and-elearning' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/k12-and-elearning' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      // document.getElementById('main_header').classList.add('homepageHeader');
      $.getScript('../../../../assets/js/hubslider.js', function () { });
      $.getScript('../../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../../assets/js/wisepop.js', function () { });
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
      AOS.init();
    }
  }
  
}
